import type { ListBuilderList } from '../../../types';
import { createShopNewlyStockedColumns } from '../columns';
import {
	SHOP_MOBILE_CARD_CONFIG,
	SHOP_NEWLY_STOCKED_REQUIRED_FIELDS,
} from '../shared';

/**
 * Shop Newly Stocked list configuration
 * Items in stock that were created (in the source system or locally) within
 * the last 30 days, sorted by COALESCE(externalCreatedDate, _created_date) DESC.
 */
export const shopNewlyStockedList: ListBuilderList = {
	id: 'shop_newly_stocked',
	cacheTTL: 600000,
	name: 'Newly Stocked',
	type: 'default',
	active: true,
	sortOrder: 9,
	columns: createShopNewlyStockedColumns(),
	description: 'Items added in the last 30 days that are currently in stock',
	defaultSortId: 'column-created_date-desc',
	requiredFields: SHOP_NEWLY_STOCKED_REQUIRED_FIELDS,
	mobileCardConfig: SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'newly_stocked',
					label: 'Newly Stocked',
				},
			],
		},
	},
};
